import { createFileRoute } from '@tanstack/react-router';

import { PortalFacturas } from '@/features/portal/portal-facturas';

export const Route = createFileRoute('/portal/facturas')({
  component: PortalFacturas,
});
